if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
        this.variantLifestyleThumbsCarousel = false;
      }

      connectedCallback() {
        FoxTheme.Motion.inView(
          this,
          this.init.bind(this)
        );
      }

      init() {
        console.time('gallery');

        if (this._initialized) return;

        this._initialized = true;

        this.elements =
          window.FoxTheme.utils.queryDomNodes(
            this.selectors,
            this
          );

        this.mediaLayout =
          this.dataset.mediaLayout;

        this.onlyImage =
          this.dataset.onlyImage === 'true';

        this.enableDesktopSlider =
          this.dataset.enableDesktopSlider ===
          'true';

        this.enableMobileThumbnails =
          this.dataset.enableMobileThumbnails ===
          'true';

        this.enableImageZoom =
          this.dataset.enableImageZoom ===
          'true';

        this.setSliderOptions();

        const mql = window.matchMedia(
          FoxTheme.config.mediaQueryMobile
        );

        mql.onchange =
          this.updateMediaLayout.bind(this);

        this.updateMediaLayout();

        if (
          this.mediaLayout ===
          'columns-variant'
        ) {
          this.initColumnsVariantLayout();
        }

        if (
          this.mediaLayout ===
          'lifestyle-carousel'
        ) {
          this.initLifestyleCarouselLayout();
        }

        if (
          this.mediaLayout ===
          'variant-lifestyle'
        ) {
          this.initVariantLifestyleLayout();
        }

        if (this.enableImageZoom) {
          this.initImageZoom();
        }

        console.timeEnd('gallery');
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(
          this.dataset.mediaItemGap
        );

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,

          navigation: {
            nextEl:
              this.querySelector(
                '.swiper-button-next'
              ),

            prevEl:
              this.querySelector(
                '.swiper-button-prev'
              ),
          },

          pagination: {
            el:
              this.querySelector(
                '.swiper-pagination'
              ),

            clickable: true,
            type: 'fraction',
          },

          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,

          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },

          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions =
              Object.assign(
                {},
                this.thumbsOptions,
                {
                  breakpoints: {
                    768: {
                      direction:
                        'vertical',

                      slidesPerView:
                        'auto',
                    },
                  },
                }
              );

            break;

          case 'slider-freemode':
            this.sliderOptions =
              Object.assign(
                {},
                this.sliderOptions,
                {
                  slidesPerView:
                    'auto',
                }
              );

            break;
        }
      }

      updateMediaLayout() {
        if (
          this.mediaLayout ===
            'lifestyle-carousel' ||
          this.mediaLayout ===
            'variant-lifestyle'
        ) {
          return;
        }

        if (
          FoxTheme.config.mqlMobile
        ) {
          this.initSlider();
        } else if (
          this.enableDesktopSlider
        ) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (
          typeof this.sliderInstance ===
          'object'
        ) {
          return;
        }

        if (
          (
            this.enableDesktopSlider ||
            this.enableMobileThumbnails
          ) &&
          this.elements.thumbnails
        ) {
          this.thumbsInstance =
            new window.FoxTheme.Carousel(
              this.elements.thumbnails,
              this.thumbsOptions
            );

          this.thumbsInstance.init();

          this.sliderOptions.thumbs = {
            swiper:
              this.thumbsInstance.slider,

            autoScrollOffset: 2,
          };
        }

        this.sliderInstance =
          new window.FoxTheme.Carousel(
            this.elements.viewer,
            this.sliderOptions,
            [
              FoxTheme.Swiper.Thumbs,
            ]
          );

        this.sliderInstance.init();

        this.handleSliderAfterInit();
        this.handleSlideChange();

        this.sliderInstance.slider.init();
      }

      destroySlider() {
        if (
          typeof this.sliderInstance !==
          'object'
        ) {
          return;
        }

        this.sliderInstance.slider.destroy();

        this.sliderInstance = false;
      }

      initThumbsSlider() {
        if (
          typeof this.thumbsInstance ===
          'object'
        ) {
          return;
        }

        this.thumbsInstance =
          new window.FoxTheme.Carousel(
            this.selectors.thumbnails,
            this.thumbsOptions
          );

        this.thumbsInstance.init();
      }

      initImageZoom() {
        if (
          this.mediaLayout ===
          'variant-lifestyle'
        ) {
          return;
        }

        if (
          this.mediaLayout ===
          'lifestyle-carousel'
        ) {
          this.initLifestyleZoom();

          return;
        }

        const dataSource = [];

        const allMedia = [
          ...this.querySelectorAll(
            '.product__media-item:not(.swiper-slide-duplicate)'
          ),
        ];

        allMedia.forEach(
          (media) => {
            switch (
              media.dataset.mediaType
            ) {
              case 'model':
                dataSource.push({
                  id:
                    media.dataset.mediaIndex,

                  html: `
                    <div class="pswp__item--${media.dataset.mediaType}">
                      ${
                        media.querySelector(
                          'product-model'
                        ).outerHTML
                      }
                    </div>
                  `,

                  mediaType:
                    media.dataset.mediaType,
                });

                break;

              case 'video':
              case 'external_video':
                dataSource.push({
                  id:
                    media.dataset.mediaIndex,

                  html: `
                    <div class="pswp__item--${media.dataset.mediaType}">
                      ${
                        media.querySelector(
                          'video-element'
                        ).outerHTML
                      }
                    </div>
                  `,

                  mediaType:
                    media.dataset.mediaType,
                });

                break;

              case 'image':
                dataSource.push({
                  id:
                    media.dataset.mediaIndex,

                  src:
                    media.dataset.src,

                  width:
                    media.dataset.pswpWidth,

                  height:
                    media.dataset.pswpHeight,

                  mediaType:
                    media.dataset.mediaType,
                });

                break;
            }
          }
        );

        this.pswpDataSource =
          dataSource;

        this.lightbox =
          new window.FoxTheme.PhotoSwipeLightbox(
            {
              dataSource,

              pswpModule:
                window.FoxTheme.PhotoSwipe,

              bgOpacity: 1,
              arrowPrev: false,
              arrowNext: false,
              zoom: false,
              close: false,
              counter: false,
              preloader: false,
            }
          );

        this.lightbox.init();
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on(
          'afterInit',
          (swiper) => {
            const {
              slides,
              activeIndex,
            } = swiper;

            if (
              !slides[activeIndex]
            ) {
              return;
            }

            const isModel =
              slides[
                activeIndex
              ].dataset.mediaType ===
              'model';

            this.toggleSliderDraggableState(
              !isModel
            );
          }
        );
      }

      handleSlideChange() {
        this.sliderInstance.slider.on(
          'realIndexChange',
          (swiper) => {
            const {
              slides,
              activeIndex,
              thumbs,
            } = swiper;

            if (
              thumbs.swiper
            ) {
              thumbs.swiper.slideTo(
                activeIndex
              );
            }

            if (
              !slides[activeIndex]
            ) {
              return;
            }

            this.playActiveMedia(
              slides[activeIndex]
            );

            const isModel =
              slides[
                activeIndex
              ].dataset.mediaType ===
              'model';

            this.toggleSliderDraggableState(
              !isModel
            );
          }
        );
      }

      toggleSliderDraggableState(
        isDraggable
      ) {
        if (
          this.sliderInstance.slider
            .allowTouchMove ===
          isDraggable
        ) {
          return;
        }

        this.sliderInstance.slider.allowTouchMove =
          isDraggable;
      }

      playActiveMedia(
        selected
      ) {
        const deferredMedia =
          selected.querySelector(
            'product-model'
          );

        if (
          deferredMedia
        ) {
          deferredMedia.loadContent(
            false
          );
        }
      }

      setActiveMedia(
        variant
      ) {
        if (
          !variant ||
          !variant.featured_media
        ) {
          return;
        }

        if (
          this.mediaLayout ===
          'columns-variant'
        ) {
          this.updateColumnsVariantLayout(
            variant
          );

          return;
        }

        if (
          this.mediaLayout ===
          'lifestyle-carousel'
        ) {
          this.updateLifestyleCarouselLayout(
            variant
          );

          return;
        }

        if (
          this.mediaLayout ===
          'variant-lifestyle'
        ) {
          this.updateVariantLifestyleLayout(
            variant
          );

          return;
        }

        if (
          this.sliderInstance &&
          this.sliderInstance.slider
        ) {
          const slides =
            Array.from(
              this.sliderInstance
                .slider.slides
            );

          const index =
            slides.findIndex(
              (slide) =>
                slide.dataset.mediaId ==
                variant.featured_media.id
            );

          if (
            index !== -1
          ) {
            this.sliderInstance.slider.slideTo(
              index,
              0
            );
          }
        } else {
          this.sortMediaItems(
            variant
          );
        }
      }

      /* ======================================
         VARIANT + LIFESTYLE GALLERY
      ====================================== */

      initVariantLifestyleLayout() {
        this.variantLifestyleMain =
          this.querySelector(
            '[data-variant-lifestyle-main]'
          );

        this.variantLifestyleMainImage =
          this.variantLifestyleMain?.querySelector(
            'img'
          );

        this.variantLifestyleMainContainer =
          this.variantLifestyleMain?.querySelector(
            '.product__media-container'
          );

        this.variantLifestylePackshotThumb =
          this.querySelector(
            '[data-variant-lifestyle-packshot-thumb]'
          );

        this.variantLifestylePackshotThumbImage =
          this.variantLifestylePackshotThumb?.querySelector(
            'img'
          );

        this.variantLifestyleThumbnails =
          this.querySelector(
            '[data-variant-lifestyle-thumbnails]'
          );

        this.variantLifestylePrevButton =
          this.querySelector(
            '[data-variant-lifestyle-prev]'
          );

        this.variantLifestyleNextButton =
          this.querySelector(
            '[data-variant-lifestyle-next]'
          );

        this.variantLifestyleThumbsWrap =
          this.querySelector(
            '.variant-lifestyle-thumbnails-wrap'
          );

        const dataElement =
          this.querySelector(
            '[data-variant-lifestyle-media]'
          );

        if (
          dataElement
        ) {
          try {
            this.variantLifestyleMedia =
              JSON.parse(
                dataElement.textContent
              );
          } catch (
            error
          ) {
            console.error(
              'Could not parse variant lifestyle media',
              error
            );

            this.variantLifestyleMedia =
              {};
          }
        } else {
          this.variantLifestyleMedia =
            {};
        }

        /*
         * Click main image to zoom.
         * Applies to packshot + lifestyle.
         */
        if (
          this.variantLifestyleMain
        ) {
          this.variantLifestyleMain.addEventListener(
            'click',
            () => {
              const isZoomed =
                this.classList.toggle(
                  'is-image-zoomed'
                );

              if (
                !isZoomed
              ) {
                this.resetVariantLifestyleZoomPosition();
              }
            }
          );

          /*
           * Follow cursor while zoomed.
           */
          this.variantLifestyleMain.addEventListener(
            'pointermove',
            (event) => {
              if (
                event.pointerType ===
                  'touch' ||
                !this.classList.contains(
                  'is-image-zoomed'
                )
              ) {
                return;
              }

              const rect =
                this.variantLifestyleMain.getBoundingClientRect();

              if (
                !rect.width ||
                !rect.height
              ) {
                return;
              }

              const x =
                Math.max(
                  0,
                  Math.min(
                    100,
                    (
                      (
                        event.clientX -
                        rect.left
                      ) /
                      rect.width
                    ) *
                      100
                  )
                );

              const y =
                Math.max(
                  0,
                  Math.min(
                    100,
                    (
                      (
                        event.clientY -
                        rect.top
                      ) /
                      rect.height
                    ) *
                      100
                  )
                );

              this.variantLifestyleMain.style.setProperty(
                '--zoom-x',
                `${x}%`
              );

              this.variantLifestyleMain.style.setProperty(
                '--zoom-y',
                `${y}%`
              );
            }
          );
        }

        /*
         * Preload gallery images.
         */
        const preloadSources =
          new Set();

        this.querySelectorAll(
          '[data-variant-lifestyle-thumb]'
        ).forEach(
          (thumbnail) => {
            if (
              thumbnail.dataset.imageSrc
            ) {
              preloadSources.add(
                thumbnail.dataset.imageSrc
              );
            }
          }
        );

        Object.values(
          this.variantLifestyleMedia ||
            {}
        ).forEach(
          (media) => {
            if (
              media?.src
            ) {
              preloadSources.add(
                media.src
              );
            }

            if (
              media?.thumb_src
            ) {
              preloadSources.add(
                media.thumb_src
              );
            }
          }
        );

        preloadSources.forEach(
          (src) => {
            const image =
              new Image();

            image.src =
              src;
          }
        );

        /*
         * Lifestyle thumbnails.
         */
        this.querySelectorAll(
          '[data-variant-lifestyle-thumb]'
        ).forEach(
          (thumbnail) => {
            thumbnail.addEventListener(
              'click',
              () => {
                this.showVariantLifestyleImage(
                  thumbnail
                );
              }
            );

            thumbnail.addEventListener(
              'keydown',
              (event) => {
                if (
                  event.key ===
                    'Enter' ||
                  event.key ===
                    ' '
                ) {
                  event.preventDefault();

                  this.showVariantLifestyleImage(
                    thumbnail
                  );
                }
              }
            );
          }
        );

        /*
         * Packshot thumbnail.
         */
        if (
          this.variantLifestylePackshotThumb
        ) {
          this.variantLifestylePackshotThumb.addEventListener(
            'click',
            () => {
              this.restoreVariantLifestylePackshot();
            }
          );

          this.variantLifestylePackshotThumb.addEventListener(
            'keydown',
            (event) => {
              if (
                event.key ===
                  'Enter' ||
                event.key ===
                  ' '
              ) {
                event.preventDefault();

                this.restoreVariantLifestylePackshot();
              }
            }
          );
        }

        this.initVariantLifestyleThumbsCarousel();

        this.setVariantLifestyleActiveThumbnail(
          this.variantLifestylePackshotThumb
        );
      }

      initVariantLifestyleThumbsCarousel() {
        if (
          !this.variantLifestyleThumbnails ||
          this.variantLifestyleThumbsCarousel
        ) {
          return;
        }

        const totalSlides =
          this.variantLifestyleThumbnails.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-duplicate)'
          ).length;

        /*
         * Desktop arrows only when
         * there are actually 6+ thumbnails.
         */
        const showDesktopNavigation =
          totalSlides > 5;

        if (
          this.variantLifestyleThumbsWrap
        ) {
          this.variantLifestyleThumbsWrap.classList.toggle(
            'has-navigation',
            showDesktopNavigation
          );
        }

        [
          this.variantLifestylePrevButton,
          this.variantLifestyleNextButton,
        ].forEach(
          (button) => {
            if (
              !button
            ) {
              return;
            }

            button.hidden =
              !showDesktopNavigation;

            if (
              showDesktopNavigation
            ) {
              button.style.removeProperty(
                'display'
              );
            } else {
              button.style.display =
                'none';
            }
          }
        );

        const gap =
          parseInt(
            this.dataset.mediaItemGap
          ) || 12;

        this.variantLifestyleThumbsCarousel =
          new window.FoxTheme.Carousel(
            this.variantLifestyleThumbnails,
            {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: gap,
              loop: false,
              freeMode: false,
              watchSlidesProgress:
                true,
              threshold: 2,

              breakpoints: {
                768: {
                  slidesPerView: 5,
                },
              },
            }
          );

        this.variantLifestyleThumbsCarousel.init();

        const slider =
          this.variantLifestyleThumbsCarousel
            .slider;

        if (
          !slider
        ) {
          return;
        }

        if (
          showDesktopNavigation &&
          this.variantLifestylePrevButton
        ) {
          this.variantLifestylePrevButton.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              slider.slidePrev();
            }
          );
        }

        if (
          showDesktopNavigation &&
          this.variantLifestyleNextButton
        ) {
          this.variantLifestyleNextButton.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              slider.slideNext();
            }
          );
        }

        const updateNavigation =
          () => {
            if (
              !showDesktopNavigation
            ) {
              return;
            }

            if (
              this.variantLifestylePrevButton
            ) {
              this.variantLifestylePrevButton.classList.toggle(
                'swiper-button-disabled',
                slider.isBeginning
              );
            }

            if (
              this.variantLifestyleNextButton
            ) {
              this.variantLifestyleNextButton.classList.toggle(
                'swiper-button-disabled',
                slider.isEnd
              );
            }
          };

        slider.on(
          'slideChange',
          updateNavigation
        );

        slider.on(
          'resize',
          updateNavigation
        );

        updateNavigation();
      }

      resetVariantLifestyleZoomPosition() {
        this.variantLifestyleMain?.style.removeProperty(
          '--zoom-x'
        );

        this.variantLifestyleMain?.style.removeProperty(
          '--zoom-y'
        );
      }

      resetVariantLifestyleZoom() {
        this.classList.remove(
          'is-image-zoomed'
        );

        this.resetVariantLifestyleZoomPosition();
      }

      restoreVariantLifestylePackshot() {
        const thumbnail =
          this.variantLifestylePackshotThumb;

        if (
          !thumbnail ||
          !this.variantLifestyleMainImage
        ) {
          return;
        }

        const src =
          thumbnail.dataset.imageSrc;

        const width =
          Number(
            thumbnail.dataset.imageWidth ||
              0
          );

        const height =
          Number(
            thumbnail.dataset.imageHeight ||
              0
          );

        const mediaId =
          thumbnail.dataset.mediaId ||
          '';

        const alt =
          thumbnail.dataset.imageAlt ||
          '';

        if (
          !src
        ) {
          return;
        }

        this.classList.remove(
          'is-lifestyle-active'
        );

        this.resetVariantLifestyleZoom();

        this.setVariantLifestyleActiveThumbnail(
          thumbnail
        );

        this.scrollVariantLifestyleThumbTo(
          thumbnail,
          250
        );

        this.variantLifestyleMainImage.removeAttribute(
          'srcset'
        );

        this.variantLifestyleMainImage.removeAttribute(
          'sizes'
        );

        this.variantLifestyleMainImage.src =
          src;

        this.variantLifestyleMainImage.alt =
          alt;

        if (
          width
        ) {
          this.variantLifestyleMainImage.width =
            width;
        }

        if (
          height
        ) {
          this.variantLifestyleMainImage.height =
            height;
        }

        if (
          this.variantLifestyleMainContainer &&
          width &&
          height
        ) {
          this.variantLifestyleMainContainer.style.setProperty(
            '--aspect-ratio',
            width /
              height
          );
        }

        if (
          this.variantLifestyleMain
        ) {
          this.variantLifestyleMain.dataset.mediaId =
            mediaId;
        }
      }

      setVariantLifestyleActiveThumbnail(
        activeThumbnail
      ) {
        this.querySelectorAll(
          '[data-variant-lifestyle-thumb], [data-variant-lifestyle-packshot-thumb]'
        ).forEach(
          (item) => {
            item.removeAttribute(
              'aria-current'
            );

            const container =
              item.querySelector(
                '.product__thumbs-container'
              );

            if (
              container
            ) {
              container.style.outline =
                '';

              container.style.boxShadow =
                '';
            }
          }
        );

        if (
          !activeThumbnail
        ) {
          return;
        }

        activeThumbnail.setAttribute(
          'aria-current',
          'true'
        );

        const activeContainer =
          activeThumbnail.querySelector(
            '.product__thumbs-container'
          );

        if (
          activeContainer
        ) {
          /*
           * No black box.
           * Just a quiet grey underline.
           */
          activeContainer.style.outline =
            'none';

          activeContainer.style.boxShadow =
            '0 2px 0 rgba(0, 0, 0, 0.16)';
        }
      }

      scrollVariantLifestyleThumbTo(
        thumbnail,
        speed = 250
      ) {
        const slider =
          this.variantLifestyleThumbsCarousel
            ?.slider;

        if (
          !slider ||
          !thumbnail
        ) {
          return;
        }

        const slides =
          Array.from(
            slider.slides ||
              []
          );

        const index =
          slides.indexOf(
            thumbnail
          );

        if (
          index > -1
        ) {
          slider.slideTo(
            index,
            speed
          );
        }
      }

      showVariantLifestyleImage(
        thumbnail
      ) {
        if (
          !this.variantLifestyleMainImage
        ) {
          return;
        }

        const src =
          thumbnail.dataset.imageSrc;

        const width =
          Number(
            thumbnail.dataset.imageWidth ||
              0
          );

        const height =
          Number(
            thumbnail.dataset.imageHeight ||
              0
          );

        if (
          !src
        ) {
          return;
        }

        this.classList.add(
          'is-lifestyle-active'
        );

        this.resetVariantLifestyleZoom();

        this.setVariantLifestyleActiveThumbnail(
          thumbnail
        );

        this.scrollVariantLifestyleThumbTo(
          thumbnail
        );

        const thumbnailImage =
          thumbnail.querySelector(
            'img'
          );

        this.variantLifestyleMainImage.removeAttribute(
          'srcset'
        );

        this.variantLifestyleMainImage.removeAttribute(
          'sizes'
        );

        this.variantLifestyleMainImage.src =
          src;

        if (
          thumbnailImage?.alt
        ) {
          this.variantLifestyleMainImage.alt =
            thumbnailImage.alt;
        }

        if (
          width
        ) {
          this.variantLifestyleMainImage.width =
            width;
        }

        if (
          height
        ) {
          this.variantLifestyleMainImage.height =
            height;
        }

        if (
          this.variantLifestyleMainContainer &&
          width &&
          height
        ) {
          this.variantLifestyleMainContainer.style.setProperty(
            '--aspect-ratio',
            width /
              height
          );
        }
      }

      updateVariantLifestyleLayout(
        variant
      ) {
        if (
          !variant ||
          !this.variantLifestyleMainImage
        ) {
          return;
        }

        this.variantLifestyleCurrentVariant =
          variant;

        this.classList.remove(
          'is-lifestyle-active'
        );

        this.resetVariantLifestyleZoom();

        const media =
          this.variantLifestyleMedia?.[
            String(
              variant.id
            )
          ];

        if (
          !media ||
          !media.src
        ) {
          return;
        }

        /*
         * Update first thumbnail.
         */
        if (
          this.variantLifestylePackshotThumbImage &&
          media.thumb_src
        ) {
          this.variantLifestylePackshotThumbImage.removeAttribute(
            'srcset'
          );

          this.variantLifestylePackshotThumbImage.removeAttribute(
            'sizes'
          );

          this.variantLifestylePackshotThumbImage.src =
            media.thumb_src;

          this.variantLifestylePackshotThumbImage.alt =
            media.alt ||
            '';
        }

        /*
         * Update packshot data stored
         * directly on first thumbnail.
         */
        if (
          this.variantLifestylePackshotThumb
        ) {
          this.variantLifestylePackshotThumb.dataset.imageSrc =
            media.src;

          this.variantLifestylePackshotThumb.dataset.imageWidth =
            media.width ||
            0;

          this.variantLifestylePackshotThumb.dataset.imageHeight =
            media.height ||
            0;

          this.variantLifestylePackshotThumb.dataset.mediaId =
            media.media_id ||
            '';

          this.variantLifestylePackshotThumb.dataset.imageAlt =
            media.alt ||
            '';
        }

        this.setVariantLifestyleActiveThumbnail(
          this.variantLifestylePackshotThumb
        );

        this.scrollVariantLifestyleThumbTo(
          this.variantLifestylePackshotThumb,
          0
        );

        this.variantLifestyleMainImage.removeAttribute(
          'srcset'
        );

        this.variantLifestyleMainImage.removeAttribute(
          'sizes'
        );

        this.variantLifestyleMainImage.src =
          media.src;

        this.variantLifestyleMainImage.alt =
          media.alt ||
          '';

        if (
          media.width
        ) {
          this.variantLifestyleMainImage.width =
            media.width;
        }

        if (
          media.height
        ) {
          this.variantLifestyleMainImage.height =
            media.height;
        }

        if (
          this.variantLifestyleMainContainer &&
          media.width &&
          media.height
        ) {
          this.variantLifestyleMainContainer.style.setProperty(
            '--aspect-ratio',
            media.width /
              media.height
          );
        }

        if (
          this.variantLifestyleMain
        ) {
          this.variantLifestyleMain.dataset.mediaId =
            media.media_id ||
            '';
        }
      }

      sortMediaItems(
        variant
      ) {
        const newMedias =
          Array.from(
            this.elements.mediaItems ||
              []
          ).sort(
            (a, b) =>
              Number(
                a.dataset.mediaIndex
              ) -
              Number(
                b.dataset.mediaIndex
              )
          );

        const matchIndex =
          newMedias.findIndex(
            (media) =>
              media.dataset.mediaId ==
              variant.featured_media.id
          );

        if (
          matchIndex > -1
        ) {
          const [el] =
            newMedias.splice(
              matchIndex,
              1
            );

          newMedias.unshift(
            el
          );
        }

        this.elements.mediaList.innerHTML =
          '';

        newMedias.forEach(
          (media) =>
            this.elements.mediaList.appendChild(
              media
            )
        );
      }
    }
  );
}